export const TECHNICAL_SHEET_OVERRIDE = 'TechnicalSheetOverride';
export const OverrideStageValues = ['CADASTRO', 'PRODUCAO'];
export const ScopeTypeValues = ['COLOR', 'OPTION', 'MACHINE'];
//# sourceMappingURL=technical-sheet-override.js.map